<template>
  <component :is="currentService" :serviceId="serviceId"></component>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import MailService from './MailService'
import SerialPortService from './SerialPortService'
import MQService from './MQService'
import ChatService from './ChatService'
import { UnsavedChecker } from 'services'

export default {
  name: 'service-main',
  mixins: [UnsavedChecker.mixin],
  props: ['serviceId', 'serviceType'],

  components: { MailService, SerialPortService, MQService, ChatService },

  data() {
    return {}
  },

  computed: {
    currentService() {
      switch (this.serviceType) {
        case 'MAIL':
          return 'MailService'
        case 'SERIALPORT':
          return 'SerialPortService'
        case 'MQ':
          return 'MQService'
        case 'CHAT':
          return 'ChatService'
      }
      return 'MailService'
    }
  }
}
</script>
